















































































































import { AdgroupFormData, AdType, CampaignFormData } from '@tt4b/ttam-enums';
import { i18n } from '@tt4b/ttam-i18n';
import { computed, defineComponent, PropType, toRefs } from '@vue/composition-api';
import TtamLearnMore from '@/components/common/learn-more/index.vue';
import TtamAdFormatCommonCard from '../common/type-card.vue';
import { useCreativeActionTypeIs, useStdAdgroupIs } from '@tt4b/ttam-hooks';
import ALink from '@/components/common/a-link/a-link.vue';
const name = 'ttam-ad-format-normal';

export default defineComponent({
  name,
  components: { TtamLearnMore, TtamAdFormatCommonCard, ALink },
  props: {
    smallGap: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    currentAdType: { type: Number as PropType<AdType>, default: undefined },
    isIconVisible: { type: Boolean, default: false },
    isCollectionAds: { type: Boolean, default: false },
    /** 是否展示 CA 类型 */
    isCollectionAdsTypeVisible: { type: Boolean, default: true },
    /** 是否限制普通创意 */
    isRestrictNormalCreative: { type: Boolean, default: false },
    /** 是否限制 CA 创意 */
    isRestrictCollectionCreative: { type: Boolean, default: false },
    adTypeList: {
      type: Array as PropType<
        {
          icon: string;
          type: string;
          title: string;
          desc: string;
          tip?: string;
          disabled?: boolean;
          disabledTips?: string;
        }[]
      >,
      default: () => [],
    },
    createMode: {
      type: String,
      default: 'create',
    },
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    isDefaultCatalogCarousel: {
      type: Boolean,
      default: false,
    },
  },

  setup(props, ctx) {
    const { adgroupData, campaignData, createMode } = toRefs(props);
    const { isLiveAds } = useStdAdgroupIs({
      adgroupFormData: adgroupData,
      campaignFormData: campaignData,
    });
    const { isCopy, isExistAdgroup } = useCreativeActionTypeIs({
      createMode,
      adgroupFormData: adgroupData,
    });
    const copyExistingAdgroup = computed(() => isCopy.value && isExistAdgroup.value);
    const isCopyLiveAdsRealTime = computed(
      () => item =>
        copyExistingAdgroup.value &&
        props.currentAdType === AdType.SINGLE_VIDEO &&
        item.type === AdType.REAL_TIME_LIVE &&
        isLiveAds.value,
    );
    const normalCreativeTip = computed(() => item => {
      if (isCopyLiveAdsRealTime.value(item)) {
        return i18n.t('module_live_ads_realtime_live_cant_select');
      } else {
        return props.isRestrictNormalCreative ? i18n.t('') : '';
      }
    });
    const displayTips = computed(
      () => props.adTypeList.find(({ type }) => Number(type as unknown as AdType) === props.currentAdType)?.tip || '',
    );

    function getIsTypeActive(type: AdType) {
      if (props.isCollectionAds) {
        return false;
      }

      return props.currentAdType === type;
    }

    function normalChange(item) {
      ctx.emit('normal-change', item);
    }

    function caChange() {
      ctx.emit('ca-change');
    }
    const containerClass = [
      'ttam-ad-format-normal-container',
      props.smallGap ? 'ttam-ad-format-normal-container-small-gap' : '',
    ];
    return {
      name,
      // adTypeListForShow,
      normalCreativeTip,
      isCopyLiveAdsRealTime,
      caChange,
      containerClass,
      normalChange,
      getIsTypeActive,
      displayTips,
      AdType,
    };
  },
});
